// apps/web/src/components/ui/Skeleton.tsx
//
// Loading skeleton. Use a single rectangle (with optional child
// blocks) that pulses; avoid stacking more than ~5 blocks to keep
// the perceived load time honest.

import type { ReactNode } from 'react';

export function SkeletonBlock({ className }: { className?: string }): JSX.Element {
  return (
    <div
      aria-hidden="true"
      className={[
        'animate-pulse rounded bg-gray-200 dark:bg-gray-800',
        className ?? 'h-4 w-full',
      ].join(' ')}
    />
  );
}

export function SkeletonList({ rows = 3 }: { rows?: number }): JSX.Element {
  return (
    <div role="status" aria-busy="true" aria-live="polite" className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonBlock key={i} className="h-12 w-full" />
      ))}
    </div>
  );
}

export function SkeletonCard({ children }: { children?: ReactNode }): JSX.Element {
  return (
    <div className="rounded border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-gray-900">
      {children ?? <SkeletonBlock className="h-6 w-40" />}
    </div>
  );
}
